import PropTypes from "prop-types";
import { useCallback, useMemo } from "react";

import { Form } from "@/components";

/**
 * Generic settings tab with form state management and delegated content rendering.
 *
 * @param root0 - The component props.
 * @param root0.name - The tab name identifier.
 * @param root0.onChangeState - Callback when the tab form state changes.
 * @param root0.model - The settings model data.
 * @param root0.renderContent - The function that renders the tab content.
 * @returns The rendered settings tab.
 */
const SettingsTab = ({ name, onChangeState, model = {}, renderContent }) => {
    const changeFormState = useCallback(
        (state) => {
            onChangeState?.(state);
        },
        [onChangeState],
    );

    const FormControl = useMemo(() => bindFormControl(name), [name]);

    return renderContent?.({ model, changeFormState, FormControl });
};

const bindFormControl =
    (prefix) =>
    ({ children, name, ...props }) => (
        <Form.FormControl {...props} name={`${prefix}-${name}`}>
            {children}
        </Form.FormControl>
    );

SettingsTab.propTypes = {
    name: PropTypes.string.isRequired,
    onChangeState: PropTypes.func,
    onSave: PropTypes.func,
    model: PropTypes.any,
    renderContent: PropTypes.func,
};

export default SettingsTab;
